import {
	DEFINED_BY, COMPONENT_OF, INHERITS, IS_A,
} from '~/scripts/constants/common-kids';

export default class LinkStyle {
	/**
	 * Instantiates a LinkStyle
	 */
	constructor() {
		this.type = 'Straight';
		this.color = 'default';
		this.dash = 0;
		this.width = 2;
	}

	export() {
		return {
			type:  this.type,
			color: this.color,
			dash:  this.dash,
			width: this.width,
		};
	}

	/**
	 * Get the CSS definition of the LinkStyle object
	 *
	 * @returns {string} CSS definition
	 */
	getCSS() {
		return [
			'kn-action',
			`kn-action-color-${this.color}`,
			`kn-action-dash-${this.dash}`,
			`kn-action-width-${this.width}`,
		].join(' ');
	}

	/**
	 * Update the style according to relation
	 *
	 * @param {string} relation Relation
	 */
	updateStyleFromRelation(relation) {
		switch (relation) {
		case DEFINED_BY: {
			this.color = 'default';
			this.dash = 0;
			this.width = 2;
			break;
		}

		case COMPONENT_OF: {
			this.color = 'info';
			this.dash = 0;
			this.width = 3;
			break;
		}

		case INHERITS: {
			this.color = 'danger';
			this.dash = 0;
			this.width = 3;
			break;
		}

		case IS_A: {
			this.color = 'muted';
			this.dash = 5;
			this.width = 2;
			break;
		}

		default: {
			this.color = 'muted';
			this.dash = 0;
			this.width = 2;
			break;
		}
		}
	}
}
